import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { FileSearchResultFragmentDoc } from '../../fragments/generated/fileSearchResult';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FileSearchQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.FilesFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FileSearchQuery = { files?: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, category: Types.FileCategoryEnum, projectStatus?: Types.FileProjectStatusEnum | null, systemGenerated?: boolean | null, childrenIds?: Array<string> | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null } }> | null } | null };


export const FileSearchDocument = /*#__PURE__*/ gql`
    query fileSearch($filters: FilesFilters, $sort: [SortType!], $first: Float, $after: String) {
  files(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...FileSearchResult
      }
    }
  }
}
    ${FileSearchResultFragmentDoc}`;

export function useFileSearchQuery(options?: Omit<Urql.UseQueryArgs<FileSearchQueryVariables>, 'query'>) {
  return Urql.useQuery<FileSearchQuery, FileSearchQueryVariables>({ query: FileSearchDocument, ...options });
};